import React from "react";
import { ToastContainer } from "react-toastify";
import ViewBlog from "../../components/Blog/ViewBlog";

export const ViewBlogPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewBlog />
        </div>
      </div>
    </div>
  );
};
